(() => {
  const selector = 'h1, h2, h3, h4, h5, h6, p, [data-element-no-orphan]';
  const whitespaceBeforeLastWord = /[ \t\r\n\f]+(?=\S+[ \t\r\n\f]*$)/u;

  function protectLastTwoWords(element) {
    if (!(element instanceof HTMLElement)) return;
    if (element.closest('script, style, noscript, textarea, [contenteditable="true"]')) return;
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue || !/\S/u.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    for (let index = textNodes.length - 1; index >= 0; index -= 1) {
      const node = textNodes[index];
      if (!whitespaceBeforeLastWord.test(node.nodeValue)) continue;
      node.nodeValue = node.nodeValue.replace(whitespaceBeforeLastWord, '\u00a0');
      element.dataset.elementOrphanProtected = 'true';
      return;
    }
  }

  function applyOrphanProtection(root = document) {
    if (root instanceof HTMLElement && root.matches(selector)) protectLastTwoWords(root);
    root.querySelectorAll?.(selector).forEach(protectLastTwoWords);
  }

  function boot() {
    applyOrphanProtection();
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'characterData' && mutation.target.parentElement) {
          const copyElement = mutation.target.parentElement.closest(selector);
          if (copyElement) protectLastTwoWords(copyElement);
        }
        mutation.addedNodes.forEach((node) => {
          if (node instanceof HTMLElement) applyOrphanProtection(node);
        });
      }
    });
    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
